module.exports = " \n\n  \n  <div class=\"col-md-12\">\n    <!-- Thsi is all in the footer .. -->\n  </div>\n\n "